// Distintiu visual (només icona) per diferenciar d'un cop d'ull els ingredients
// envasats/processats —els que tenen codi de barres— dels venuts a granel.
// És purament informatiu: no canvia cap comportament (unitats, agregació…).
// El significat va al `title`/`aria-label` per a accessibilitat i tooltip.
export function IngredientKindIcon({
  packaged,
  size = 14,
  style,
}: {
  packaged: boolean;
  size?: number;
  style?: React.CSSProperties;
}) {
  const wrap: React.CSSProperties = {
    display: "inline-flex",
    flexShrink: 0,
    lineHeight: 0,
    ...style,
  };

  if (packaged) {
    return (
      <span
        title="Envasat · amb codi de barres"
        aria-label="Envasat"
        style={{ ...wrap, color: "var(--accent-soft-foreground)" }}
      >
        {/* Codi de barres */}
        <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden>
          <rect x="3" y="5" width="2.2" height="14" rx="0.5" />
          <rect x="7" y="5" width="1.1" height="14" rx="0.4" />
          <rect x="10" y="5" width="2.2" height="14" rx="0.5" />
          <rect x="13.8" y="5" width="1.1" height="14" rx="0.4" />
          <rect x="16.3" y="5" width="2.4" height="14" rx="0.5" />
          <rect x="20.3" y="5" width="1.1" height="14" rx="0.4" />
        </svg>
      </span>
    );
  }

  return (
    <span
      title="A granel · sense codi de barres"
      aria-label="A granel"
      style={{ ...wrap, color: "var(--faint)" }}
    >
      {/* Balança: es ven a pes */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <path d="M12 6v13M7.5 19h9M4 8h16" />
        <path d="M4 8l-2.2 4.3a2.2 2.2 0 0 0 4.4 0L4 8z" />
        <path d="M20 8l-2.2 4.3a2.2 2.2 0 0 0 4.4 0L20 8z" />
        <circle cx="12" cy="5" r="1.4" fill="currentColor" stroke="none" />
      </svg>
    </span>
  );
}
